import React, {useState} from 'react'
import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import Button from '../../global/Button'
import InputNumber from '../../global/InputNumber'
import AddFavourite from '../../global/AddFavourite'
import ProductImage from '../ProductImage'
import BannerResultV2 from '../banners/BannerResultV2'
import cameraOff from '../../../assets/img/icons/camera-off.svg'
import DisplayTechnology from './displays/DisplayTechnology'
import DisplayBlackIndicator from './displays/DisplayBlackIndicator'
import Slider from 'react-slick'
import DisplayEclosBrand from './displays/DisplayEclosBrand'

const RectangleResultV2UI = props => {
    const limit = props.getLimit()

    const showValidImage = () => {
        if (props.product.detailImage && props.product.detailImage !== 'null' && props.product.detailImage !== undefined && props.product.detailImage !== 'undefined')
            return props.product.detailImage
        if (props.product.imgLarge && (props.product.imgLarge !== 'null' || props.product.imgLarge != 'null')) return props.product.imgLarge
        return cameraOff
    }

    const placeHolderClassName = () => {
        if (!props.product.detailImage || props.product.detailImage === 'null' || !props.product.imgLarge || props.product.imgLarge === 'null' || props.product.imgLarge == 'null')
            return '--placeholder'
        return ''
    }

    const extras = () => {
        return props.getExtras()
    }

    const isCosentinoBrazil = () => {
        return extras() && extras().isCosentinoBrazil
    }
    
    const isCosentinoGlobal = () => {
        return extras() && extras().isCosentinoGlobal
    }

    const slickSettings = {
        arrows: false,
        swipeToSlide: true,
        dots: false,
        speed: 750,
        autoplaySpeed: 7500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        variableWidth: false,
        pauseOnHover: true
    }

    const CustomSlide = (props) => {
        const [isMovin, setIsMovin] = useState(false)

        const { id, bannerUrl, bannerTitle, bannerText } = props;
        const handleClick = e => {
            if (isMovin) e.preventDefault()
        }

        return (
            <div className="box-parent-banner-result-v2"
                 style={{ background: 'white', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}
                 onDragStart={e => {
                     e.preventDefault()
                 }}
                 onMouseDown={e => {
                     if (isMovin===true) setIsMovin(false)
                 }}
                 onMouseMove={e => {
                     if (isMovin===false) setIsMovin(true)
                 }}
            >
                <LocalizedLink routeId="ROUTE_PROMOTION_LANDING"
                               params={{ promotionId: id }}
                               gtmLabel="ec_banner_list"
                               style={{height:"100%"}}
                               onClick={handleClick}
                >
                    <div className="d-md-block position-relative box-parent-banner-result-v2"
                         style={{ backgroundImage: `url(${bannerUrl})`,backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'center' }}>
                        <div className="text_banner text_banner--filters" style={{position:"absolute", fontSize:"8px", top:"25%", width:"100%"}}>
                            <div dangerouslySetInnerHTML={{ __html: bannerTitle }} />
                            <div dangerouslySetInnerHTML={{ __html: bannerText }} />
                        </div>

                        <div style={{position:"absolute", bottom:"10%", width:"100%"}}>
                            <LocalizedLink routeId="ROUTE_PROMOTION_LANDING"
                                           params={{ promotionId: id }}
                                           gtmLabel="ec_banner_list"
                            >
                                <Button inverted size="large"
                                        style={{borderRadius:"4px", paddingBlock:"24px", paddingInline: "48px", margin: "auto", width:"fit-content"}}
                                >
                                    <Translation id="view_section" defaultMessage="View section" />
                                </Button>
                            </LocalizedLink>
                        </div>
                    </div>
                </LocalizedLink>
            </div>
        )
    }

    return (
        <React.Fragment>
            {/********************************************* BANNERS **************************************************/}
            {props.result &&
                props.index === 4 &&
                props.location.pathname.includes(props.intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', '')) &&
                !props.isHideAllBannerCatalog &&
                !props.isIkeaCenter && (
                    <React.Fragment>
                        {props.hasPromotionLandingActivated &&
                            <Slider {...slickSettings}>
                                {props.promotionData.map(p => {
                                    const bannerTitle = p.banner_title ? (p.banner_title[props.locale] ? p.banner_title[props.locale] : p.banner_title[p.banner_title.default]) : null
                                    const bannerText = p.banner_text ? (p.banner_text[props.locale] ? p.banner_text[props.locale] : p.banner_text[p.banner_text.default]) : null

                                    return <CustomSlide id={p.id}
                                                         bannerUrl={p.lateral_banner_url}
                                                         bannerTitle={bannerTitle}
                                                         bannerText={bannerText}
                                    />
                                })}
                            </Slider>
                        }
                        {(!props.hasPromotionLandingActivated
                            && props.currentLocation.section !== 'basin'
                            && props.currentLocation.section !== 'productos_estandar'
                        ) && (
                            <BannerResultV2 currentLocation={props.currentLocation} naturalStoneViewingPermissions={props.naturalStoneViewingPermissions}/>
                        )}
                    </React.Fragment>
                )}
            {/********************************************** FIN BANNERS *********************************************/}

            <div
                className={`rectangle-result-v2 v2 ${props.size && props.size === 'S' ? 'small' : ''} ${props.mallPromotionSection ? 'mall-promo' : ''} ${
                    props.product.fromMall ? 'landing-mall' : ''
                }`}
                data-cy="catalog__product_rectangle_result"
                data-key={props.product.productId}
                data-color={props.product.colorId}
                type={props.getTypeProductForStyles()}
            >
                {(!props.product.fromMall || props.showImg) && (
                    <div className="wrapper-product-image">
                        {props.indicators}

                        {props.canOnlyViewOutlet ? (
                            props.product.lotViewAvailable === undefined || props.product.lotViewAvailable ? (
                                <LocalizedLink routeId="ROUTE_LOTS" params={{ id: props.product.productId, outlet: 'outlet' }}>
                                    <ProductImage product={props.product} state={props.state} intl={props.intl} />
                                </LocalizedLink>
                            ) : (
                                <ProductImage product={props.product} state={props.state} intl={props.intl} />
                            )
                        ) : (
                            <LocalizedLink
                                routeId="ROUTE_PRODUCT_DETAIL"
                                params={{ id: props.product.productId, outlet: props.outlet ? 'outlet' : '' }}
                                onClick={() => props.goToProductCard(props.product)}
                            >
                                {/* Show the custom upload image or normal image of Mall Campaigns */}
                                {props.product.fromMall ? (
                                    <div className={'product-image-container ' + placeHolderClassName()}>
                                        <div
                                            className="product-image"
                                            style={{
                                                backgroundColor: 'white',
                                                backgroundImage: 'url("' + showValidImage() + '")',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center'
                                            }}
                                        >
                                            <div className="product-image-technology">
                                                <div className="technology-content">
                                                    <DisplayEclosBrand isBrandEclos={props.product.brand == 'ECLOS' ? true : false}/>
                                                    <DisplayTechnology technology={props.product.technology} subBrand={props.product.subBrand} brand={props.product && props.product.brand}/>
                                                </div>

                                                {props.canViewPricesPhase3 &&
                                                    props.state &&
                                                    props.state.promotions &&
                                                    props.state.promotions.length > 0 &&
                                                    (props.state.promotions[0].dealType === 'A' ? (
                                                        <div className="d-flex">
                                                            <DisplayBlackIndicator value={props.intl.formatMessage({ id: 'new_price' })} />
                                                        </div>
                                                    ) : props.state.promotions[0].dealType === 'B' ? (
                                                        <div className="d-flex">
                                                            <DisplayBlackIndicator value={`-${props.state.promotions[0].value}%`} />
                                                        </div>
                                                    ) : null)}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <ProductImage product={props.product} state={props.state} intl={props.intl} />
                                )}
                            </LocalizedLink>
                        )}
                        {!props.product.fromMall && <AddFavourite productId={props.product.productId} />}
                    </div>
                )}

                {props.details}

                {props.canBuy && (
                    (props.isLatinaVitoria && ['SENSA', 'SCALEA', 'PREXURY'].includes(props.product.brand)) ? (
                /* {props.canBuy &&
                    (props.showLotsInPortfolio(props.product, !!props.outlet, isCosentinoBrazil()) ? ( */
                        props.getStock() > 0 ? (
                            <div className="pb-3 px-3">
                                <LocalizedLink
                                    routeId="ROUTE_LOTS"
                                    params={{ id: props.product.productId, outlet: '' }}
                                    onClick={() => {
                                        props.product.extra = props.getExtras()
                                        props.setLastSelectedProduct(props.product)
                                    }}
                                >
                                    <Button>
                                        <Translation id="view_lots" defaultMessage="View lots" />
                                    </Button>
                                </LocalizedLink>
                            </div>
                        ) : (
                            <div className="pb-3 px-3">
                                <Button disabled={true}>
                                    <Translation id="view_lots" defaultMessage="View lots" />
                                </Button>
                            </div>
                        )
                    ) : (
                        <React.Fragment>
                            <div className={`product-actions ${props.mallPromotionSection ? 'mall' : ''}`}>
                                {!props.product.haveOptions && !props.mallPromotionSection && (
                                    <div className="input-row">
                                        <div className="input">
                                            <InputNumber
                                                value={props.getValueToAdd()}
                                                change={qty => props.state.setQtyToAdd(qty)}
                                                step={props.isIkeaCenter && props.product.unit === 'M2' ? 0.01 : props.getStep()}
                                                limit={limit}
                                                min={props.getMin()}
                                                decimals={props.isIkeaCenter && props.product.unit === 'M2' ? 2 : 0}
                                                disabled={!props.canBuyBrand()}
                                                isCosentinoBrazil={isCosentinoBrazil()}
                                                isCosentinoGlobal={isCosentinoGlobal()}
                                                naturalStoneViewingPermissions={props.naturalStoneViewingPermissions}
                                                triggerIncrementDecrementNaturalStoneQty={props.triggerIncrementDecrementNaturalStoneQty}
                                                productName={props.product.displayName}
                                            />
                                        </div>
                                    </div>
                                )}
                                {props.mallPromotionSection && (
                                    <LocalizedLink
                                        routeId="ROUTE_PRODUCT_DETAIL"
                                        params={{ id: props.product.productId, outlet: props.outlet ? 'outlet' : '' }}
                                        onClick={() => {
                                            if (props.indexOfList !== undefined) props.clickDetail(props.product, props.list, props.indexOfList)
                                        }}
                                        style={{ width: '100%' }}
                                    >
                                        <Button>
                                            <span className="btn-add-to-cart-text">
                                                <Translation id="view_more" defaultMessage="View more" />
                                            </span>
                                        </Button>
                                    </LocalizedLink>
                                )}
                                <div className="bt-row">
                                    {props.product.haveOptions ? (
                                        props.canOnlyViewOutlet ? (
                                            (props.product.lotViewAvailable === undefined || props.product.lotViewAvailable) && (
                                                <LocalizedLink routeId="ROUTE_LOTS" params={{ id: props.product.productId, outlet: 'outlet' }}>
                                                    <Button icon="shopping-cart" size="small" customClass="cart">
                                                        <Translation id="options" defaultMessage="Options" />
                                                    </Button>
                                                </LocalizedLink>
                                            )
                                        ) : (
                                            <LocalizedLink routeId="ROUTE_PRODUCT_DETAIL" params={{ id: props.product.productId, outlet: props.outlet ? 'outlet' : '' }}>
                                                <Button icon="shopping-cart" size="small" customClass="cart">
                                                    <Translation id="options" defaultMessage="Options" />
                                                </Button>
                                            </LocalizedLink>
                                        )
                                    ) : (
                                        <Button
                                            far={true}
                                            icon={props.canBuyBrand() ? "cart-shopping" : ""}
                                            inverted
                                            customClass="add-to-cart-button"
                                            disabled={props.isAdding || (limit != null ? limit : 1) <= 0 || !props.state.qtyToAdd >= 1 || !props.canBuyBrand()}
                                            onClick={() => props.addToCart()}
                                            dataQas="global_product-add-to-cart-button"
                                        >
                                            <span className="btn-add-to-cart-text">
                                                {props.canBuyBrand() ? (
                                                    <Translation id="add" defaultMessage="add" />
                                                ) : (                                
                                                    <Translation id="coming_soon_for_sale" defaultMessage="Coming soon for sale" />
                                                )}
                                            </span>
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
            </div>
        </React.Fragment>
    )
}

export default RectangleResultV2UI
